import { getAnalytics, logEvent } from 'firebase/analytics'
import config from '../Config'
import { firebaseApp } from '../Services/firebase'

/* Analytics events (spec 9.10). Never let analytics break the page. */
let analytics = null
try {
  analytics = getAnalytics(firebaseApp())
} catch (e) {
  analytics = null
}

export function track(name, params) {
  if (config.IS_DEV) console.debug('[analytics]', name, params || '')
  if (!analytics) return
  try {
    logEvent(analytics, name, params)
  } catch (e) {
    // ignore
  }
}
